"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require("./global_components/card_component.js");

var _card_component2 = _interopRequireDefault(_card_component);

var _ramda = require("ramda");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _accessibility_utility = require("../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SampleWithdrawalCard = function (_React$Component) {
    _inherits(SampleWithdrawalCard, _React$Component);

    function SampleWithdrawalCard() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SampleWithdrawalCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SampleWithdrawalCard.__proto__ || Object.getPrototypeOf(SampleWithdrawalCard)).call.apply(_ref, [this].concat(args))), _this), _this.renderDataRow = function (label, value) {
            var columnLeft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
            var columnRight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6;

            var maxWidth = 12;
            if (columnRight === 6) {
                columnRight = maxWidth - columnLeft;
            }

            var columnLeftClassNames = "col-xs-" + columnLeft + " col-sm-" + columnLeft + " col-md-" + columnLeft + " col-lg-" + columnLeft + " col-xlg-" + columnLeft;
            var columnRightClassNames = "col-xs-" + columnRight + " col-sm-" + columnRight + " col-md-" + columnRight + " col-lg-" + columnRight + " col-xlg-" + columnRight;

            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "span",
                    {
                        className: "text-left " + columnLeftClassNames + " category white-space-default",
                        "data-testid": 'sample-withdrawal-label'
                    },
                    label
                ),
                _react2.default.createElement(
                    "span",
                    {
                        className: "text-right " + columnRightClassNames + " float-right category word-wrap-break",
                        "data-testid": 'sample-withdrawal-value'
                    },
                    value
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SampleWithdrawalCard, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var sampleWithdrawalAmountDp = (0, _ramda.pathOr)(null, ['fund', 'breakdowns', 'sampleWithdrawalAmountDp'], this.props);
            if ((0, _ramda.isNil)(sampleWithdrawalAmountDp) || (0, _ramda.isNil)(sampleWithdrawalAmountDp.date) || (0, _ramda.isNil)(sampleWithdrawalAmountDp.displayValue)) {
                return null;
            }

            var dateMoment = (0, _moment2.default)(sampleWithdrawalAmountDp.date);

            if (!dateMoment.isValid()) {
                return null;
            }

            var value = sampleWithdrawalAmountDp.displayValue;
            var headerTitle = _string_utility2.default.renderFormattedLabel("Sample Withdrawal Amount", "pdp-overview-sample-withdrawal");
            var backgroundRowClasses = "row margin-vertical-0 margin-horizontal--30 padding-top-20 padding-horizontal-24 border-light-grey";
            var tooltipDisclosureId = 'pdpDataPointSampleWithdrawalAmount';
            var customStyle = { verticalAlign: 'top' };
            var disclosureIcon = this.props.showHeaderIcon ? _react2.default.createElement("span", {
                id: "disclosure-" + tooltipDisclosureId,
                tabIndex: 0,
                className: "icon-info v-middle print-hide padding-left-5",
                style: customStyle,
                role: "tooltip",
                onKeyDown: function onKeyDown(event) {
                    return _accessibility_utility2.default.handleEnterClick(_this2, event, function () {
                        return _functional_utility2.default.handleDisclosureIconClick(_this2, event, tooltipDisclosureId);
                    });
                },
                onClick: function onClick(event) {
                    return _functional_utility2.default.handleDisclosureIconClick(_this2, event, tooltipDisclosureId);
                }
            }) : null;

            return _react2.default.createElement(
                _card_component2.default,
                {
                    className: "print-full-width",
                    dataTest: "sample-withdrawal",
                    headerTitle: headerTitle,
                    headerTitleId: "sample-withdrawal-headerTitle",
                    headerRightInline: disclosureIcon,
                    displayStyle: 'width-percent-100 float-left margin-right-3',
                    breakpoint: this.props.breakpoint,
                    is25PercentCard: true
                },
                _react2.default.createElement(
                    "div",
                    { key: 'sample-withdrawal', className: "" + backgroundRowClasses },
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-12 padding-left-0 padding-right-0 float-none" },
                        this.renderDataRow(dateMoment.year(), value)
                    )
                )
            );
        }
    }]);

    return SampleWithdrawalCard;
}(_react2.default.Component);

exports.default = SampleWithdrawalCard;